import { useSelector } from "react-redux";

export const useCanView = () => {
  
  const dataUser = useSelector(state => state.auth.login.dataUser);
  const userPermissions = dataUser?.permises || [];

  const canView = (screenName, permissionType) => {
    const permission = userPermissions.find(
      (p) => p.screen === screenName.toUpperCase() && p[permissionType] === true
    );
    console.log(`Checking permission for ${screenName} with type ${permissionType}:`, permission);
    return !!permission; 
  };

  return canView;
};
